"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _components = require("../../components");

var _Global = require("../../styles/Global.style");

var _DocumentHeader = require("./DocumentHeader.style");

var DocumentHeader = function DocumentHeader(_ref) {
  var documentHeaderData = _ref.documentHeaderData;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Global.Section, null, /*#__PURE__*/_react.default.createElement(_DocumentHeader.HeaderWrapper, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "header-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "table"
  }, documentHeaderData && Object.keys(documentHeaderData).filter(function (key) {
    return documentHeaderData[key];
  }).map(function (key, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "table-col",
      key: "".concat(key).concat(i)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "header-key table-col-body"
    }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
      title: key
    }), key), /*#__PURE__*/_react.default.createElement("div", {
      className: "table-col-body"
    }, documentHeaderData[key]));
  }))))));
};

exports.DocumentHeader = DocumentHeader;